import { render, staticRenderFns } from "./TP1.vue?vue&type=template&id=6aece9de&"
import script from "./TP1.vue?vue&type=script&lang=js&"
export * from "./TP1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports